import React from "react";
import TodoList from "./TodoList";

const App = () => {
  return (
    <div>
      <TodoList />
    </div>
  );
};

export default App;
